<template>
  <el-tooltip v-bind="$attrs"><slot /></el-tooltip>
</template>

<script>
export default {
  name: 'RtTooltip'
}
</script>


// WEBPACK FOOTER //
// rtTooltip.vue?6230e712